import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { Home } from '../../components/Home';
import {
  STORE_ADVERT,
  STORE_AUTH,
  STORE_VIDEO,
  AdvertSlot
} from '../../constants';
import { Video } from '../../models';
import { AdvertStore, AuthStore, VideoStore } from '../../stores';
import './style.css';

export interface HomePageProps extends RouteComponentProps<{}> {
  /* [STORE_VIDEO]: VideoStore; */
}

export interface HomePageState {
  /* empty */
}

export const FEATURED_VIDEO_CAROUSEL_DURATION = 5000;

@inject(STORE_ADVERT)
@inject(STORE_AUTH)
@inject(STORE_VIDEO)
@observer
export class HomePage extends React.Component<HomePageProps, HomePageState> {
  // Initial render
  async componentDidMount() {
    await this.loadHomePageData();
  }

  // Prop updates (e.g. when navigating from video to video)
  async UNSAFE_componentWillReceiveProps() {
    await this.loadHomePageData();
  }

  render() {
    const videoStore = this.props[STORE_VIDEO] as VideoStore;
    const advertStore = this.props[STORE_ADVERT] as AdvertStore;
    const authStore = this.props[STORE_AUTH] as AuthStore;

    return (
      <Home
        adverts={advertStore.adverts}
        featuredVideos={videoStore.featuredVideos}
        featuredVideosError={!!videoStore.featuredLoading.error}
        featuredVideosLoading={videoStore.featuredLoading.running}
        loggedIn={!!authStore.currentUser}
        onFavourite={this.onFavourite}
        pageUrl={this.props.match.url}
        recentlyAdded={videoStore.recentlyAddedVideos}
        recentlyAddedError={!!videoStore.recentlyAddedLoading.error}
        recentlyAddedLoading={videoStore.recentlyAddedLoading.running}
        savingFavourite={!!videoStore.favouritingVideo.running}
        videoError={!!videoStore.videosLoading.error}
        videoLoading={videoStore.videosLoading.running}
      />
    );
  }

  private loadHomePageData = async () => {
    const videoStore = this.props[STORE_VIDEO] as VideoStore;
    const advertStore = this.props[STORE_ADVERT] as AdvertStore;

    await advertStore.fetchAdvertsForSlot(AdvertSlot.HomepageBanner);

    // Load the recently added + featured videos
    await videoStore.fetchRecentlyAddedVideos();
    await videoStore.fetchFeaturedVideos();
  };

  private onFavourite = (video: Video): void => {
    const videoStore = this.props[STORE_VIDEO] as VideoStore;

    videoStore.favouriteVideo(video);
  };
}



// WEBPACK FOOTER //
// ./src/app/containers/HomePage/index.tsx